<template>
  <div class="container">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item class="black">{{
        t("vehiclemanagement")
      }}</a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link :to="`${routerName.vehiclelist}`">{{
          t("vehiclelist")
        }}</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="currentrouter">{{
        t("scheduledtasks")
      }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="search-input-group">
      <a-input
        style="width: 17%"
        v-model:value="keyWord"
        :placeholder="t('entermapname')"
      />
      <a-button class="searchBtn" @click="search">{{ t("search") }}</a-button>
    </div>
    <a-table
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
      :scroll="{ y: maxHeight, x: 1700 }"
    >
      <template v-slot:bodyCell="{ text, column, index }">
        <template v-if="column.title === t('serialnumber')">
          {{ index + 1 }}</template
        >
        <template v-if="column.title === t('repetitionperiod')">
          <span v-for="(item, index) in text" :key="index">
            {{ convertToChineseNumeral(item) }}
          </span>
        </template>
        <template v-if="column.title === t('cleaningmode')">
          {{ getCleanMode(text, t) }}</template
        >
      </template>
    </a-table>
    <a-pagination
      class="pagination"
      show-size-changer
      show-quick-jumper
      :show-total="(total) => `${t('intotal')} ${total}${t('article')}`"
      v-model:current="pagination.page"
      v-model:pageSize="pagination.size"
      :total="pagination.total"
      size="small"
      @change="getListData"
    />
  </div>
</template>
<script>
import Api from "@/api/userService";
import { getCleanMode } from "@/constant/DataType";
import ResultCodeType from "@/constant/ResultCodeType";
import routerName from "@/router/routerName";
import { message } from "ant-design-vue";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
export default {
  name: "ScheduledTasks",
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const maxHeight = computed(() => store.getters.getMaxHeight);
    const dataSource = ref();
    const route = useRoute();
    const vin = route.query.vin;
    const pagination = ref({
      page: 1,
      size: 10,
      total: 0,
    });
    const keyWord = ref("");
    const getListData = () => {
      const params = {
        page: pagination.value.page,
        size: pagination.value.size,
        vin,
      };
      if (keyWord.value) {
        params.keyword = keyWord.value;
      }
      Api.getScheduledTasksList(params).then((res) => {
        if (res.err_no == ResultCodeType.success_200) {
          dataSource.value = res.result;
          pagination.value.total = res.totalNum * 1;
        } else {
          message.error(res.err_msg);
        }
      });
    };
    const search = () => {
      pagination.value.page = 1;
      getListData();
    };
    const convertToChineseNumeral = (num) => {
      const chineseNumerals = {
        1: t("monday"),
        2: t("tuesday"),
        3: t("wednesday"),
        4: t("thursday"),
        5: t("friday"),
        6: t("saturday"),
        7: t("sunday"),
      };
      return chineseNumerals[num] || "";
    };
    onMounted(() => {
      getListData();
    });
    return {
      dataSource,
      columns: [
        {
          title: t("serialnumber"),
          dataIndex: "index",
          key: "index",
          align: "center",
        },
        {
          title: t("taskname"),
          dataIndex: "task_name",
          key: "task_name",
          align: "center",
        },
        {
          title: t("mapname"),
          dataIndex: "map_name",
          key: "map_name",
          align: "center",
        },
        {
          title: t("starttime"),
          dataIndex: "start_time",
          key: "start_time",
          align: "center",
        },
        {
          title: t("forcedendtime"),
          dataIndex: "force_end_time",
          key: "force_end_time",
          align: "center",
        },
        {
          title: t("repetitionperiod"),
          dataIndex: "cycle_period",
          key: "cycle_period",
          align: "center",
        },
        {
          title: t("cleaningfrequency"),
          dataIndex: "cycle_num",
          key: "cycle_num",
          align: "center",
        },
        {
          title: t("cleaningmode"),
          dataIndex: "parameter_id",
          key: "parameter_id",
          align: "center",
        },
        {
          title: t("expectedendtime"),
          dataIndex: "estimate_finish_time",
          key: "estimate_finish_time",
          align: "center",
        },
        {
          title: t("timeconsuming"),
          dataIndex: "time_console",
          key: "time_console",
          align: "center",
        },
      ],
      keyWord,
      getListData,
      pagination,
      getCleanMode,
      convertToChineseNumeral,
      search,
      maxHeight,
      routerName,
      t,
    };
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>
